import { type UseQueryResult, useQuery } from 'react-query';
import { OptionExerciseSharedService, // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto } from '@wealthlane/api-services/wealthlane-award-service';

const useGetExerciseHistoryList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto[] | undefined,
  unknown
> => {
  const exerciseHistoryList = useQuery(['getExerciseHistoryList'], async () => {
    return await handleRequest(
      OptionExerciseSharedService.getApiAwardApiAppOptionExerciseExerciseListByAwardId(id)
    );
  });

  return exerciseHistoryList;
};

export default useGetExerciseHistoryList;
